// extracted by mini-css-extract-plugin
export var body = "_mf-0";
export var sectionHeader = "_mf-4";
export var shortcutColumns = "_mf-2";
export var shortcutList = "_mf-1";
export var shortcutSection = "_mf-3";